import React from 'react';
import './RankSkinsNewsModal.css';
import MenuPromoModal from '../MenuPromoModal/MenuPromoModal';
import {FACTIONS} from '../../../constants/factions';
import {LEAGUES} from '../../../constants/leagues';
import {getFactionRankImagePath} from '../../../utils/factions/getFactionRankImagePath';
import {getFactionRankSkinTitle} from '../../../utils/factions/getFactionRankSkinTitle';

const PAGE_ID = 'RankSkinsNewsModal';

/**
 * Новость в главном меню: за победы в рейтинговых матчах теперь даются новые
 * эпические обличия фракций. Картинка — рейтинговое обличие людей Рубиновой
 * Лиги. Корпус — общий для промо-модалок меню (MenuPromoModal), подсветка и
 * заголовок — цвета кристаллов, как у модалки кристаллов за рейтинг.
 *
 * Кому и когда показывать, решает меню (см. checkIfRankSkinsNewsDue):
 * один раз на аккаунт и ниже всех остальных модалок меню. Обе кнопки ведут в
 * onClose — там меню ставит отметку показа; «Посмотреть в коллекции»
 * вдобавок открывает коллекцию на «Рейтинговых обличиях». Сама модалка на
 * сервер не ходит: ее же открывает превью в админке (AdminModalsTestPage)
 *
 * @param {Function} onOpenCollection
 * @param {Function} onClose
 */
const RankSkinsNewsModal = ({onOpenCollection, onClose}) => (
  <MenuPromoModal
    pageId={PAGE_ID}
    title={'Новые рейтинговые обличия!'}
    imagePath={getFactionRankImagePath(FACTIONS.HUMANS, LEAGUES.RUBY)}
    imageAlt={getFactionRankSkinTitle(FACTIONS.HUMANS, LEAGUES.RUBY)}
    modalClassName={'rank-skins-news-modal'}
    titleClassName={'text-crystals'}
    action={{
      buttonId: 'open_collection',
      label: 'Посмотреть в коллекции',
      onClick: onOpenCollection,
    }}
    onClose={onClose}
  >
    <p className={'menu-promo-modal_text'}>
      Теперь за победы в <span className={'text-crystals'}>рейтинговых матчах</span> можно
      {' '}получить <span className={'text-crystals'}>новые эпические обличия</span> фракций.
      Загляни в коллекцию и посмотри, какие из них тебя ждут!
    </p>
  </MenuPromoModal>
);

export default RankSkinsNewsModal;
